import Search from './Search';

export default Search;
export { Search };
export type { SearchProps, SearchInstance } from './types';
